var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Card",
    {
      scopedSlots: _vm._u(
        [
          _vm.$scopedSlots.actions
            ? {
                key: "footer",
                fn: function () {
                  return [_vm._t("actions")]
                },
                proxy: true,
              }
            : null,
        ],
        null,
        true
      ),
    },
    [
      _c(
        "div",
        { staticClass: "w-full flex" },
        [
          _c("div", [
            _c(
              "div",
              [
                _c(
                  "RouterLink",
                  { attrs: { to: _vm.routeParams } },
                  [
                    _c("TableAvatar", {
                      staticClass: "cursor-pointer text-primary-500",
                      attrs: {
                        image: _vm.avatar,
                        initial: _vm.initials,
                        title: _vm.fullName,
                        avatarClasses: "h-8 w-8",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "flex flex-wrap justify-between noWidthLabelContainer",
              },
              [
                _c("CardBodyItem", {
                  staticClass: "card-item w-48 mr-6",
                  attrs: {
                    label: "Job title",
                    labelClass: "mr-2",
                    content: _vm.job,
                  },
                }),
                _c("CardBodyItem", {
                  staticClass: "card-item w-48 mr-6",
                  attrs: {
                    label: "Location",
                    labelClass: "mr-2",
                    content: _vm.locationString,
                  },
                }),
                _vm._t("default"),
              ],
              2
            ),
          ]),
          _vm._t("secondary"),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }